module.exports = __webpack_public_path__ + "components/social-footer/static/envelope-c164a1ef5d411efd92be6c2be05a2eb6.svg";